import { render, staticRenderFns } from "./ResetPassWithOTP.vue?vue&type=template&id=5c2aa0f0&scoped=true"
import script from "./ResetPassWithOTP.vue?vue&type=script&lang=js"
export * from "./ResetPassWithOTP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2aa0f0",
  null
  
)

export default component.exports